import { PageShell, Section } from '~/components/layout';
import { CtaBanner, FaqAccordion } from '~/components/sections';
import { ZakatCalculator } from '~/components/sections/ZakatCalculator';
import { ButtonLink } from '~/components/ui';
import { getAppCta } from '~/content/navigation';

export function ZakatCalculatorPage() {
  return (
    <PageShell>
      {/* Full-width grey band behind the whole hero + calculator, matching the
          send-money-home currency-calculator band (bg-grey-50). */}
      <Section className="bg-grey-50 pt-16 pb-16 md:pt-24 md:pb-24">
        <div className="mx-auto flex max-w-3xl flex-col items-center text-center">
          <h1 className="text-[40px] leading-[1.1] font-semibold tracking-[-0.03em] whitespace-pre-line text-balance md:text-title-m">
            {'Calculate your\nZakat with nsave'}
          </h1>
          <ButtonLink href={getAppCta.href} size="md" className="mt-9 md:mt-14">
            {getAppCta.label}
          </ButtonLink>
        </div>

        {/* 60px gap on mobile / 80px on desktop between the headline block and the calculator. */}
        <div className="zakat-calc-in mt-[60px] md:mt-20">
          <ZakatCalculator />
        </div>
      </Section>

      <FaqAccordion />
      <CtaBanner />
    </PageShell>
  );
}
